<template>
  <div>
  </div>
</template>
<script>
export default {
  name: "BaseForm",
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
      return  {          
        yesNoOptions: [
            { text: "Sim", value: 1, disabled: false },
            { text: "Não", value: 0, disabled: false },
        ],
      }
  },
  watch: {
    value() {
      this.$emit("input", this.value);
    },
  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>
